import { useQuery } from "@tanstack/react-query";
import { getEventsMonthService, type EventsMonthResponse } from "../services/getEventsMonthService";

export function useGetEventMonth(month: string) {
  return useQuery<EventsMonthResponse, Error>({
    queryKey: ["events-by-month", month],
    queryFn: () => getEventsMonthService(month),
    
  });
}